import AuthGate from '../../../components/feature/AuthGate';

const LiveSignalShowcase = () => {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-dark relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgxNiwgMTg1LCAxMjksIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full bg-emerald-dark/20 border border-emerald/30 mb-4 sm:mb-6">
            <i className="ri-broadcast-line text-emerald text-base sm:text-lg"></i>
            <span className="text-emerald text-xs sm:text-sm font-medium whitespace-nowrap">Canlı Karar Yayını</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-beige-light mb-4 sm:mb-6">
            Canlı Karar Yayını
          </h2>

          <p className="text-base sm:text-lg lg:text-xl text-beige/70 max-w-3xl mx-auto leading-relaxed px-4">
            BAGA, ürettiği kararları tek bir yayın sayfasında gerçek zamanlı olarak listeler. 
            Kullanıcılar piyasadaki güncel durumu sade ve hızlı şekilde takip edebilir.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12">
          <div className="bg-dark-card/50 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-emerald/10 hover:border-emerald/30 transition-all">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald/10 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-refresh-line text-emerald text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-beige-light mb-2 sm:mb-3">Sürekli Güncellenen Karar Listesi</h3>
            <p className="text-sm sm:text-base text-beige/70 leading-relaxed">
              Piyasa koşulları değiştikçe kararlar otomatik olarak güncellenir ve yayın sayfasında anında görüntülenir.
            </p>
          </div>

          <div className="bg-dark-card/50 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-emerald/10 hover:border-emerald/30 transition-all">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald/10 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-table-line text-emerald text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-beige-light mb-2 sm:mb-3">Sade Tablo Görünümü</h3>
            <p className="text-sm sm:text-base text-beige/70 leading-relaxed">
              Karmaşık grafikler yerine, anlaşılır ve hızlı okunabilir bir tablo formatında sunulur.
            </p>
          </div>

          <div className="bg-dark-card/50 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-emerald/10 hover:border-emerald/30 transition-all sm:col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald/10 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-speed-line text-emerald text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-beige-light mb-2 sm:mb-3">Anlık Piyasa Takibi</h3>
            <p className="text-sm sm:text-base text-beige/70 leading-relaxed">
              Optimize edilmiş yapısı sayesinde piyasadaki değişimleri gecikme olmadan takip edin.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-emerald/5 to-emerald-light/5 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 border border-emerald/20 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 sm:w-64 h-32 sm:h-64 bg-emerald/10 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6 sm:mb-8">
              <h3 className="text-xl sm:text-2xl font-bold text-beige-light">ÖNEMLİ NOT</h3>
              <i className="ri-information-line text-emerald text-2xl sm:text-3xl"></i>
            </div>
            
            <p className="text-base sm:text-lg text-beige/80 leading-relaxed mb-4 sm:mb-6">
              BAGA bir yatırım tavsiyesi veya grafik ekranı <strong className="text-beige-light">değildir</strong>. 
              Veri bilimi temelli <strong className="text-emerald">algoritmik karar destek platformudur</strong>.
            </p>
            
            <p className="text-sm sm:text-base text-beige/70 leading-relaxed">
              BAGA, analiz sonuçlarını paylaşmak için tasarlanmış bir karar yayın sistemidir. 
              Kullanıcılar bu sayfadan piyasanın genel durumunu hızlıca görebilir ve kendi yatırım kararlarını 
              bu bilgiler ışığında şekillendirebilir.
            </p>
          </div>
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <AuthGate>
            {(handleClick) => (
              <button
                onClick={handleClick}
                className="inline-flex items-center gap-2 sm:gap-3 bg-emerald hover:bg-emerald-light text-beige-light px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold transition-all hover:shadow-xl hover:shadow-emerald/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Canlı Yayın Sayfasına Git
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>
            )}
          </AuthGate>
        </div>
      </div>
    </section>
  );
};

export default LiveSignalShowcase;
